<script lang="ts" context="module">
	import Button from "$lib/components/Button.svelte";
	import { getClassicWebUrl } from "$lib/components/currentUser";
	import ToolbarItem from "$lib/components/toolbar/ToolbarItem.svelte";
</script>

<script lang="ts">
	const CLASSIC_WEB_URL = getClassicWebUrl();
</script>

<ToolbarItem title="Login" link="{CLASSIC_WEB_URL}/login?s=toolbar-button" visible="sm" />

<div class="hidden sm:flex">
	<Button
		url="{CLASSIC_WEB_URL}/signup?s=toolbar-button&signup_button=new-toolbar-signup-button	"
		title="Sign up now (it's free)"
		textSize="15"
		style="orange"
		width="full" />
</div>
